export class ContentServiceV1Impl {
    consumerId;
    store;
    probablyInInitialViewport;
    constructor(consumerId, store, probablyInInitialViewport) {
        this.consumerId = consumerId;
        this.store = store;
        this.probablyInInitialViewport = probablyInInitialViewport;
    }
    getContent() {
        return this.store.getContent(this.consumerId);
    }
    setContent(content) {
        this.store.setContent(this.consumerId, content);
    }
    onContentChange(listener) {
        this.store.onContentChange(this.consumerId, listener);
    }
    removeOnContentChange(listener) {
        this.store.removeOnContentChange(this.consumerId, listener);
    }
    isInInitialViewport() {
        return this.probablyInInitialViewport;
    }
}
//# sourceMappingURL=index.js.map